import React from 'react';

function LibraryDeployPasswordField({
  password,
  onChange,
  isSubmitting,
  error,
  t,
}) {
  return (
    <div className={`library-deploy-password-field form-control required${error ? ' error' : ''}`}>
      <label htmlFor="library-deploy-pro-password">
        {t('library-confirm-pro-password-label')}
      </label>
      <input
        id="library-deploy-pro-password"
        type="password"
        autoComplete="current-password"
        autoFocus
        value={password}
        onChange={onChange}
        disabled={isSubmitting}
        required
        aria-invalid={Boolean(error)}
        aria-describedby={error ? 'library-deploy-pro-error' : undefined}
      />
      {error ? (
        <span id="library-deploy-pro-error" className="error-message" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

export default LibraryDeployPasswordField;
